import {
  Id,
  QuarterFilter,
  Timestamp,
  ResumeHotel,
  FullRequestHotelsHistory
} from 'src/types'

export enum HotelsActionTypes {
  GET_HOTELS = '@hotels/GET_HOTELS',
  GET_HOTELS_FAILURE = '@hotels/GET_HOTELS_FAILURE',
  GET_HOTELS_HISTORY = '@hotels/GET_HOTELS_HISTORY',
  GET_HOTELS_HISTORY_FAILURE = '@hotels/GET_HOTELS_HISTORY_FAILURE',
  GET_HOTELS_HISTORY_SUCCESS = '@hotels/GET_HOTELS_HISTORY_SUCCESS',
  GET_HOTELS_SUCCESS = '@hotels/GET_HOTELS_SUCCESS',
  RESET_HOTELS = '@hotels/RESET_HOTELS',
  SET_HOTELS_FILTERS_NAME = '@hotels/SET_HOTELS_FILTERS_NAME',
  SET_HOTELS_FILTERS_QUARTER = '@hotels/SET_HOTELS_FILTERS_QUARTER',
  SET_HOTELS_FILTERS_QUARTER_ALL = '@hotels/SET_HOTELS_FILTERS_QUARTER__ALL',
  SET_HOTELS_NEXT_PERIOD_KEY = '@hotels/SET_HOTELS_NEXT_PERIOD_KEY',
  SET_HOTELS_PERIOD_KEY = '@hotels/SET_HOTELS_PERIOD_KEY'
}

export type HotelFilters = {
  bedrooms: number
  checkin_date: Timestamp
  checkout_date: Timestamp
  num_adults: number
  trend_destination_id: Id
}

export type HotelSelectionFilters = {
  name?: string
  quarter: QuarterFilter[]
}

export enum HotelSearchType {
  MULTIPLE_PERIOD = 'MULTIPLE_PERIOD',
  SINGLE_PERIOD = 'SINGLE_PERIOD'
}

export type HotelSearchPeriod = {
  error: string
  filters: HotelFilters
  list: ResumeHotel[]
  loading: boolean
  message_id: string[]
  selectionFilters: HotelSelectionFilters
}

export type HotelSearchPeriods = {
  [key: string]: HotelSearchPeriod
}

export type HotelsState = {
  readonly currentPeriodKey: string
  readonly historyError: string
  readonly historyList: FullRequestHotelsHistory
  readonly historyLoading: boolean
  readonly searches: HotelSearchPeriods
  readonly searchType: HotelSearchType
}
